import {TKey, useTranslation} from '@/translations/i18n'
import {MissingCoverageCard} from './missing-coverage-card'
import {
    AmenityBathroomIcon,
    AmenityBedroomIcon,
    AmenityCommonsSpacesIcon,
    AmenityDiningRoomIcon,
    AmenityExteriorIcon,
    Icon,
    AmenityKitchenIcon,
    AmenityLivingRoomIcon,
    AmenityOfficeStudyIcon,
    AmenityOtherIcon,
    AmenityOutdoorSpaceIcon,
    AmenitySwimmingPoolIcon
} from '@components/ui/icon'
import {FC} from 'react'
import {MissingCoverageSpace} from '@features/insights/types'

export type SpaceData = {label: TKey; value: number | null; icon: Icon; descriptionCard: TKey; descriptionModal: TKey}
const spaceData = {
    bathroom: {
        label: 'spaces:bathroom',
        value: null,
        icon: AmenityBathroomIcon,
        descriptionCard: 'insights:issues:spaces_text:bathroom',
        descriptionModal: 'insights:issues:spaces_text_modal:bathroom'
    },
    bedroom_1: {
        label: 'spaces:bedroom_x',
        value: 1,
        icon: AmenityBedroomIcon,
        descriptionCard: 'insights:issues:spaces_text:bedroom_x',
        descriptionModal: 'insights:issues:spaces_text_modal:bedroom_x'
    },
    bedroom_2: {
        label: 'spaces:bedroom_x',
        value: 2,
        icon: AmenityBedroomIcon,
        descriptionCard: 'insights:issues:spaces_text:bedroom_x',
        descriptionModal: 'insights:issues:spaces_text_modal:bedroom_x'
    },
    bedroom_3: {
        label: 'spaces:bedroom_x',
        value: 3,
        icon: AmenityBedroomIcon,
        descriptionCard: 'insights:issues:spaces_text:bedroom_x',
        descriptionModal: 'insights:issues:spaces_text_modal:bedroom_x'
    },
    bedroom_4: {
        label: 'spaces:bedroom_x',
        value: 4,
        icon: AmenityBedroomIcon,
        descriptionCard: 'insights:issues:spaces_text:bedroom_x',
        descriptionModal: 'insights:issues:spaces_text_modal:bedroom_x'
    },
    bedroom_5: {
        label: 'spaces:bedroom_x',
        value: 5,
        icon: AmenityBedroomIcon,
        descriptionCard: 'insights:issues:spaces_text:bedroom_x',
        descriptionModal: 'insights:issues:spaces_text_modal:bedroom_x'
    },
    bedroom_6: {
        label: 'spaces:bedroom_x',
        value: 6,
        icon: AmenityBedroomIcon,
        descriptionCard: 'insights:issues:spaces_text:bedroom_x',
        descriptionModal: 'insights:issues:spaces_text_modal:bedroom_x'
    },
    bedroom_7: {
        label: 'spaces:bedroom_x',
        value: 7,
        icon: AmenityBedroomIcon,
        descriptionCard: 'insights:issues:spaces_text:bedroom_x',
        descriptionModal: 'insights:issues:spaces_text_modal:bedroom_x'
    },
    bedroom_8: {
        label: 'spaces:bedroom_x',
        value: 8,
        icon: AmenityBedroomIcon,
        descriptionCard: 'insights:issues:spaces_text:bedroom_x',
        descriptionModal: 'insights:issues:spaces_text_modal:bedroom_x'
    },
    bedroom_9: {
        label: 'spaces:bedroom_x',
        value: 9,
        icon: AmenityBedroomIcon,
        descriptionCard: 'insights:issues:spaces_text:bedroom_x',
        descriptionModal: 'insights:issues:spaces_text_modal:bedroom_x'
    },
    bedroom_10: {
        label: 'spaces:bedroom_x',
        value: 10,
        icon: AmenityBedroomIcon,
        descriptionCard: 'insights:issues:spaces_text:bedroom_x',
        descriptionModal: 'insights:issues:spaces_text_modal:bedroom_x'
    },
    common_spaces: {
        label: 'spaces:common_spaces',
        value: null,
        icon: AmenityCommonsSpacesIcon,
        descriptionCard: 'insights:issues:spaces_text:common_spaces',
        descriptionModal: 'insights:issues:spaces_text_modal:common_spaces'
    },
    dining_room: {
        label: 'spaces:dining_room',
        value: null,
        icon: AmenityDiningRoomIcon,
        descriptionCard: 'insights:issues:spaces_text:dining_room',
        descriptionModal: 'insights:issues:spaces_text_modal:dining_room'
    },
    exterior: {
        label: 'spaces:exterior',
        value: null,
        icon: AmenityExteriorIcon,
        descriptionCard: 'insights:issues:spaces_text:exterior',
        descriptionModal: 'insights:issues:spaces_text_modal:exterior'
    },
    kitchen: {
        label: 'spaces:kitchen',
        value: null,
        icon: AmenityKitchenIcon,
        descriptionCard: 'insights:issues:spaces_text:kitchen',
        descriptionModal: 'insights:issues:spaces_text_modal:kitchen'
    },
    living_room: {
        label: 'spaces:living_room',
        value: null,
        icon: AmenityLivingRoomIcon,
        descriptionCard: 'insights:issues:spaces_text:living_room',
        descriptionModal: 'insights:issues:spaces_text_modal:living_room'
    },
    office_study: {
        label: 'commons:office_study',
        value: null,
        icon: AmenityOfficeStudyIcon,
        descriptionCard: 'insights:issues:spaces_text:office_study',
        descriptionModal: 'insights:issues:spaces_text_modal:office_study'
    },
    outdoor_space: {
        label: 'commons:outdoor_space',
        value: null,
        icon: AmenityOutdoorSpaceIcon,
        descriptionCard: 'insights:issues:spaces_text:outdoor_space',
        descriptionModal: 'insights:issues:spaces_text_modal:outdoor_space'
    },
    pool_host_tub: {
        label: 'commons:pool_host_tub',
        value: null,
        icon: AmenitySwimmingPoolIcon,
        descriptionCard: 'insights:issues:spaces_text:pool_host_tub',
        descriptionModal: 'insights:issues:spaces_text_modal:pool_host_tub'
    },
    other: {
        label: 'commons:others',
        value: null,
        icon: AmenityOtherIcon,
        descriptionCard: 'insights:issues:spaces_text:others',
        descriptionModal: 'insights:issues:spaces_text_modal:others'
    }
} as const satisfies Record<MissingCoverageSpace['keyName'], SpaceData>

interface MissingCoverageProps {
    missingCoverageData: MissingCoverageSpace[]
}
export const MissingCoverage: FC<MissingCoverageProps> = ({missingCoverageData}) => {
    const {t} = useTranslation()

    return (
        <div className="flex w-full flex-col gap-6">
            <div className="flex flex-col gap-1">
                <h4 className="text-xl font-medium">{t('insights:issues:title_coverage')}</h4>
                <p className="text-md">{t('insights:issues:description_coverages')}</p>
            </div>
            <div className="grid w-full auto-rows-auto grid-cols-1 gap-2 md:grid-cols-3 md:gap-6">
                {missingCoverageData.map(coverage => {
                    const coverageData = spaceData[coverage.keyName]

                    if (coverage.keyName == 'other') return null
                    return (
                        <MissingCoverageCard
                            icon={coverageData.icon}
                            label={coverageData.label}
                            value={coverageData.value}
                            descriptionCard={coverageData.descriptionCard}
                            descriptionModal={coverageData.descriptionModal}
                            flaggedIn={coverage.flaggedIn}
                            key={coverage.id}
                        />
                    )
                })}
            </div>
        </div>
    )
}
